export enum AttachmentType {
  Photo = 1,
  Video = 2,
  Audio = 3,
  Document = 4,
}
